import React, { useEffect, useState } from 'react';
import ReportIcon from '@mui/icons-material/AssessmentOutlined';

import { Box, Tabs, Tab, Typography, Card, CardContent, CardActions, Button } from '@mui/material';

const reports = {
  missions: [
    {
      title: 'Mission Summary Report',
      description: 'Overview of all mission activities within a selected timeframe.',
      metrics: '32 Total Missions | 75% Completed',
      link: '/reports/mission-summary',
    },
    {
      title: 'Mission Completion Rates',
      description: 'Percentage of missions completed, in progress, or not started.',
      metrics: '75% Completed | 15% In Progress',
      link: '/reports/mission-completion',
    },
  ],
  pilots: [
    {
      title: 'Pilot Performance Report',
      description: 'Evaluate individual pilot efficiency and total flight hours.',
      metrics: 'Top Pilot: John Doe | 45 hrs',
      link: '/reports/pilot-performance',
    },
    /*{
      title: 'Top Pilots by Flight Hours',
      description: 'Rank pilots by total flight hours within a timeframe.',
      metrics: 'John Doe: 45 hrs | Jane Smith: 40 hrs',
      link: '/reports/top-pilots',
    },*/
  ],
  operations: [
    /*  {
        title: 'Equipment Usage by Mission',
        description: 'Summarizes drone usage and tracks maintenance needs.',
        metrics: 'Drone A: 12 hrs | Drone B: 8 hrs',
        link: '/reports/equipment-usage',
      },
      {
        title: 'Regulatory Compliance Overview',
        description: 'Analyze mission adherence to FAA regulations.',
        metrics: '95% Compliance | 2 Warnings',
        link: '/reports/compliance-overview',
      },*/
  ],
};

const Reports = () => {
  const [activeTab, setActiveTab] = useState('missions');

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderReportCards = (reports) => (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 2,
        marginTop: 3,
        //justifyContent: 'center',
      }}
    >
      {reports.map((report, index) => (
        <Card
          key={index}
          sx={{
            boxShadow: 3,
            //maxWidth: '500px',
            //margin: '0 auto',
          }}
        >
          <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {report.title}
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {report.description}
            </Typography>
            <Typography variant="caption" color="textPrimary">
              {report.metrics}
            </Typography>
          </CardContent>
          <CardActions>
            <Button size="small" color="primary" onClick={() => window.location.href = report.link}>
              View Full Report
            </Button>
          </CardActions>
        </Card>
      ))}
    </Box>
  );

  const handleAddReport = () => {
  };

  return (
    <Box sx={{ padding: 0, backgroundColor: '#f9f9f9' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 6,
          paddingLeft: '16px',
          paddingRight: '16px',
        }}
      >
        {/* Left-aligned content */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center', // Vertically center icon and text
            gap: 1, // Add spacing between the icon and text
          }}
        >
          <ReportIcon sx={{ fontSize: '24px', color: '#2c3e50' }} />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: '#2c3e50' }}
          >
            Reports
          </Typography>
        </Box>

        {/* Right-aligned button 
        <Button
          variant="contained"
          startIcon={<ReportIcon />}
          onClick={handleAddReport}
        >
          Add Report
        </Button>
*/}
      </Box>

      <Box sx={{ width: '100%', padding: 3 }}>
        {/* Tabs for Categories */}
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          centered
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Missions" value="missions" />
          <Tab label="Pilots" value="pilots" />
          {/* <Tab label="Operations" value="operations" /> */}
        </Tabs>

        {/* Report Previews */}
        {activeTab === 'missions' && renderReportCards(reports.missions)}
        {activeTab === 'pilots' && renderReportCards(reports.pilots)}
        {/* {activeTab === 'operations' && renderReportCards(reports.operations)} */}
      </Box>

    </Box>
  );
};

export default Reports;
